import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const BookCard = ({ book, index, darkMode }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.15 }}
      whileHover={{ y: -10 }}
      className="cursor-pointer"
    >
      <div className={`${darkMode ? 'bg-white text-slate-900' : 'bg-slate-900 text-white'} h-96 rounded-xl shadow-lg p-8 flex flex-col justify-between hover:shadow-2xl transition-shadow`}>
        <div>
          <div className={`${darkMode ? 'text-slate-600' : 'text-slate-400'} text-sm mb-2`}>{book.year}</div>
          <div className={`${darkMode ? 'text-slate-700' : 'text-slate-500'} text-xs mb-4 font-medium`}>{book.author}</div>
          <h3 className={`text-2xl font-bold ${darkMode ? 'text-slate-900' : 'text-white'} mb-4 leading-tight`}>{book.title}</h3>
        </div>
        <p className={`${darkMode ? 'text-slate-700' : 'text-slate-300'} text-sm`}>{book.desc}</p>
      </div>
    </motion.div>
  );
};

export default BookCard;